import { Col, Divider, Row, Typography } from "antd";
import { useMemo } from "react";
import { Paquetes } from "../types/common";
import { StyleSheet } from "../StyleSheet";
import stylesCss from "./../views/payments.module.css";
const { Text } = Typography;

interface RechargesListComponentProps {
    packages?: Paquetes[];
    selectedId?: string | null;
    onSelect?: (pkg: Paquetes) => void;
}


const RechargesListComponent = (props: RechargesListComponentProps) => {
    const { packages = [], selectedId, onSelect } = props;

    const accentColor = "#f36f21";

    const formatDataVolume = (value: number) => {
        if (!Number.isFinite(value)) return "";
        if (value < 900) {
            return `${value}MB`;
        }
        const gb = value / 1000;
        return `${Math.round(gb)}GB`;
    };

    const packagesWithSelection = useMemo(
        () =>
            packages.map((item) => ({
                ...item,
                isSelected: selectedId === item.Id_paquete,
            })),
        [packages, selectedId]
    );

    const handleSelect = (item: Paquetes) => {
        if (onSelect) {
            onSelect(item);
        }
    };

    return (
        <Row gutter={[16, 16]} style={{ width: "100%", marginTop: 0 }} justify={"center"}>
            <Row style={styles.principal} justify={'center'}>
                <Col span={24}>
                    <Row justify={'center'}>
                        <Divider style={styles.lineDivider} />
                    </Row>
                    <Row style={{ ...styles.rowText, marginTop: 10 }} className={stylesCss.textPayments} justify={'center'}>
                        <Text>
                            ELIJE TU RECARGA
                        </Text>
                    </Row>
                </Col>
            </Row>
            {packagesWithSelection.map((item) => (
                <Col xs={24} sm={12} md={8} lg={6} key={item.Id_paquete}>
                    <Row style={{ width: "100%" }} justify="center">
                        <Col
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                backgroundColor: item.isSelected ? "#ff8800" : "#182b74",
                                width: "55%",
                                height: 35,
                                borderTopLeftRadius: 10,
                                borderTopRightRadius: 10,
                                color: "#ffffff",
                                textAlign: "center",
                                fontWeight: 650,
                                fontSize: 15,
                                padding: "10px 8px",
                            }}
                        >
                            {"RECARGA $" + item.monto}
                        </Col>
                    </Row>
                    <Row
                        role="button"
                        tabIndex={0}
                        onClick={() => handleSelect(item)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                handleSelect(item);
                            }
                        }}
                        style={{
                            cursor: "pointer",
                            border: `${item.isSelected ? "2px solid " + accentColor : "#e4e4e4"}`,
                            backgroundColor: "#f5f5f5",
                            borderRadius: 14,
                            padding: "18px 16px",
                            minHeight: 110,
                            height: 110,
                            maxHeight: 110,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Row gutter={[0, 8]} justify="center" align="middle" style={{ marginTop: 12, width: "100%" }}>
                            <Col span={8} style={{ textAlign: "center" }}>
                                <Row align="middle" justify="center" gutter={[10, 0]}>
                                    <Col>
                                        <Text style={{ color: "black", fontSize: 25, fontWeight: 800 }}>
                                            {formatDataVolume(item.datos) + "*"}
                                        </Text>
                                    </Col>
                                </Row>
                                <Row align="middle" justify="center" gutter={[10, 0]} style={{ lineHeight: -1, marginTop: -5 }}>
                                    <Col>
                                        <Text style={{ color: "black", fontSize: 10, fontWeight: 500 }}>para navegar</Text>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={2}>
                                <Text style={{ color: "#0a6dfe", fontSize: 22, fontWeight: 600 }}>
                                    +
                                </Text>
                            </Col>
                            <Col span={8} style={{ textAlign: "center" }}>
                                <Row align="middle" justify="center" gutter={[12, 0]}>
                                    <Col>
                                        <Text style={{ color: "black", fontSize: 14, fontWeight: 600 }}>
                                            {item.minutos} MIN
                                        </Text>
                                    </Col>
                                    <Col>
                                        <Text style={{ color: "black", fontSize: 13, fontWeight: 600 }}>LLAMADAS</Text>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={2}>
                                <Text style={{ color: "#0a6dfe", fontSize: 22, fontWeight: 600 }}>
                                    +
                                </Text>
                            </Col>
                            <Col span={4} style={{ textAlign: "center" }}>
                                <Row align="middle" justify="center" gutter={[12, 0]}>
                                    <Col>
                                        <Text style={{ color: "black", fontSize: 14, fontWeight: 600 }}>
                                            {item.sms}
                                        </Text>
                                    </Col>
                                    <Col>
                                        <Text style={{ color: "black", fontSize: 13, fontWeight: 600 }}>SMS</Text>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Row>
                </Col>
            ))}
        </Row>
    );
};

const styles = StyleSheet.create({
    principal: {
        padding: 15,
        marginBottom: 10,
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    lineDivider: {
        borderColor: '#c4c4c4',
        borderStyle: 'solid',
        borderWidth: 0.01,
        minWidth: "7%",
        width: "7%",
        marginBottom: 10
    },
    rowText: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    },
    rowButtons: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center'
    },
});

export default RechargesListComponent;
